export const popupTY = {
    init: function(){
        this.wrappers = [... document.querySelectorAll('[data-popup-wrapper]')];
        this.wrappers.forEach((el)=>{
            const submit = el.querySelector('[data-submit]'),
                thanky = el.querySelector('.form__thankyou');
            if ( submit && thanky ){
                submit.addEventListener('click', ()=>{
                    let interval = setInterval(()=>{
                        if ( !thanky.classList.contains('is-hidden') ){
                            thanky.focus();
                            clearInterval(interval);
                        }
                    }, 300);
                })
            }
        })
    }
}